export {
  Card,
  CardBody,
  CardFooter,
  CardFooterRow,
  CardFooterColumn,
  Tag,
  Price,
  CardDetail,
  CardDetailImage,
  CardActionButton,
} from './style';



// WEBPACK FOOTER //
// ../shop_main/components/card/index.js